var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{staticClass:"pa-0 ma-0",attrs:{"src":require("@/assets/pusha.jpg")}},[_c('div',{staticClass:"my-title"},[_vm._v(" Миша, все-таки пуща водица намного лучше лысой горы")])])}
var staticRenderFns = []

export { render, staticRenderFns }